import React from "react"
import { NavLink } from "react-router-dom"
import { createUseStyles, useTheme } from "react-jss"
import { MenuItem } from "react-pro-sidebar"
import { IChildMenuItem } from "../../util/interface"
import CustomIcon from "../CustomIcon"
const useStyles = createUseStyles({
  second_header: {
    color: "#000",
    fontFamily: ({ theme }: any) => theme.primaryFontFamily,
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "16px",
    letterSpacing: "0.438px",
  },
})
const SidebarMenuItem = ({ item }: { item: IChildMenuItem }) => {
  const theme: any = useTheme()
  const classes = useStyles({ theme })

  return (
    <MenuItem className={classes.second_header}>
      <NavLink to={item.route || "/"}>
        <span className="flex items-center">
          {item.svg && <CustomIcon path={item.svg} alt="" />}
          {item.label}
        </span>
      </NavLink>
    </MenuItem>
  )
}

export default SidebarMenuItem
